/* eslint-disable */
import { useEffect, useState } from 'react';
import { useGetBFAwardsLeaderboardQuery } from 'common/store/modules/api/cfs-api';

/**
 * If there is a live season we should call the refetchLeaderBoardData in every pollingDelay interval
 *
 * @param leaderboardData - the current leaderboard data stored as an object - object
 * @param refetchLeaderboardData - a function to refetch the leaderboard data - function
 * @param seasonPid
 * @param pollingDelay - the delay between each poll for new leaderboard data - number
 * @param eventStartDateTime - the date time at which the event starts (the closer the current time is to this date, the more frequent the polling will be)
 */
export function useLeaderboardRefetch(
    seasonPid,
    pollingDelay = PULSE.app.common.CONSTANTS.TIME.THIRTY_SECS_IN_MS,
    eventStartDateTime = '1970-01-01T00:00:00Z'
) {
    const [pollingInterval, setPollingInterval] = useState(0);

    const { data: leaderboardData, isFetching } =
        useGetBFAwardsLeaderboardQuery(
            {
                seasonId: seasonPid
            },
            {
                skip: !(seasonPid && seasonPid !== ''),
                pollingInterval: pollingInterval
            }
        );

    useEffect(() => {
        if (leaderboardData && !isFetching) {
            const leaderboardStatus = PULSE.app.common.match.getMatchStatus(
                leaderboardData?.status
            );

            if (
                leaderboardStatus ===
                PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED
            ) {
                console.info(
                    'Player Awards Leaderboard - Status COMPLETED - STOP polling'
                );
                setPollingInterval(0);
            } else if (
                leaderboardStatus ===
                    PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING ||
                leaderboardData?.status === null
            ) {
                console.info(
                    'Player Awards Leaderboard - Status UPCOMING / NULL'
                );
                const interval =
                    PULSE.app.common.getPollingInterval(eventStartDateTime);
                console.info(
                    `Player Awards Leaderboard - Next fetch in: ${interval}ms`
                );
                setPollingInterval(interval);
            } else if (
                leaderboardStatus ===
                PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE
            ) {
                console.info(
                    `Player Awards Leaderboard - Next fetch in: ${pollingDelay}`
                );
                setPollingInterval(pollingDelay);
            }
        }
    }, [isFetching, leaderboardData]);
}
